/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useContext, useEffect } from 'react';
import { CoreContext } from '../../../context/CoreContext';
import ModalWrapper from '../Wrapper';

import {
  ModalHeaderContainer,
  ModalHeaderIcon,
  ModalHeaderClose,
  ModalHeaderCloseIcon,
  ModalHeaderSpace,
  ModalContainer,
  ModalBody,
  ModalTitle,
  ModalText,
  ModalAction,
  ModalActionText,
} from './styled';

export default function ModalAlert({
  title,
  text,
  action,
  icon,
  closeable,
  setFocus,
  opened,
}: {
  title?: string;
  text?: string;
  action?: { title?: string; action?: () => void };
  icon?: Record<string, unknown>;
  closeable?: boolean;
  setFocus?: (key: string) => void;
  opened?: boolean;
}) {
  const { setModal } = useContext(CoreContext);

  const close = () => {
    setModal(null);
  };

  const handleBlurred = () => {
    setModal(null);
  };

  const handleAction = () => {
    if (action?.action && typeof action?.action === 'function') {
      action?.action();
    }
    close();
  };

  useEffect(() => {
    if (setFocus && typeof setFocus === 'function') {
      setFocus('action-button');
    }
  }, []);

  return (
    <>
      <ModalWrapper opened={opened} onBecameBlurred={handleBlurred}>
        <ModalHeaderContainer>
          <ModalHeaderSpace />
          <ModalHeaderIcon {...icon} />
          {closeable ? (
            <ModalHeaderClose onEnterPress={close} onPress={close}>
              <ModalHeaderCloseIcon />
            </ModalHeaderClose>
          ) : (
            <ModalHeaderSpace />
          )}
        </ModalHeaderContainer>
        <ModalBody>
          <ModalTitle>{title}</ModalTitle>
          <ModalText>{text}</ModalText>
          {action ? (
            <ModalAction
              focusKey={'action-button'}
              onEnterPress={handleAction}
              onPress={handleAction}
            >
              <ModalActionText>{action?.title}</ModalActionText>
            </ModalAction>
          ) : null}
        </ModalBody>
      </ModalWrapper>
    </>
  );
}
